module.exports = __webpack_public_path__ + "img/heroFormInflate.e23155a4.png";